import { render, staticRenderFns } from "./boolean-type.vue?vue&type=template&id=8f904c10&scoped=true&lang=pug&"
import script from "./boolean-type.vue?vue&type=script&lang=ts&"
export * from "./boolean-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f904c10",
  null
  
)

export default component.exports